<template>
  <div id="container" class="cart_st">
    <!-- 약관 동의 START-->
    <div class="section full">
      <div class="inner">
        <div class="btn_wrap" data-detail="shortcuts">
          <router-link :to="{ name: 'orders' }" class="box_btn line">
            <span class="c_icon ico_shortcuts_arrow"></span>
            <span class="an_t">{{ $t('views.member.editaccount.7689') }}</span>
          </router-link>
        </div>
        <div v-if="showTerms && !completeTerms" class="box_wrap">
          <AgreeBox @setTerms="setInTerms" />
        </div>
        <div
          v-if="!showTerms || completeTerms"
          class="box_wrap"
          data-detail="modify_detail"
        >
          <div class="box renew_style">
            <div class="box_title">
              <h2>{{ $t('views.member.editaccount.947') }}</h2>
              <p class="guide_txt">회원님의 개인정보를 수정하실 수 있어요.</p>
            </div>

            <ul class="form_wrap">
              <!-- 회원구분 -->

              <li class="float member_type">
                <!-- USERNAME = EMAIL -->
                <p class="sub_title">회원구분</p>
                <div class="input_wrap wid_style">
                  <label
                    :class="getCurrentUser.memberTp == '2000' ? 'opa-50' : ''"
                  >
                    <input
                      v-model="memberTp"
                      :disabled="getCurrentUser.memberTp == 2000"
                      type="radio"
                      name="member"
                      class="chk_agree"
                      value="1000"
                      @input="changingMemberTp2"
                    />
                    <em></em>
                    <span>일반회원</span>
                  </label>
                </div>
                <div class="wid_style">
                  <label>
                    <input
                      v-model="memberTp"
                      type="radio"
                      name="member"
                      class="chk_agree"
                      checked=""
                      value="2000"
                      @input="changingMemberTp2"
                    />
                    <em></em>
                    <span>교ㆍ강사 회원</span>
                  </label>
                </div>
              </li>

              <li class="name_line">
                <p class="sub_title">
                  {{ $t('views.member.editaccount.1455') }}
                </p>
                <span class="name_stl">{{ getCurrentUser.memberNm }}</span>
                <!-- <div class="input_wrap">
                  <label for="nameUpload" class="blind">이름 입력</label>
                  <input
                    id="nameUpload"
                    v-model="name"
                    class="input_t read_only"
                    type="text"
                    title="이름 입력"
                    readonly
                  />
                </div> -->
              </li>
              <li class="bir_line">
                <!-- TODO: @STAN Add date-picker here -->
                <p class="sub_title">
                  {{ $t('views.member.editaccount.6374') }}
                </p>
                <span class="bir_stl">{{ getCurrentUser.birthDate }}</span>
                <!-- <div class="input_wrap">
                  <label for="nameUpload" class="blind">생년월일 입력</label>
                  <input
                    id="birthDateUpload"
                    v-model="birthDate"
                    value-type="YYYY-MM-DD"
                    class="input_t read_only"
                    type="text"
                    title="생년월일 입력"
                    readonly
                  />
                </div> -->
              </li>
              <li class="gender_line">
                <p class="sub_title">성별</p>
                <span class="gender_stl">{{ genderText }}</span>
              </li>
              <!-- ID is now just the user's email -->
              <!-- <li>
                <p class="sub_title">{{ $t('views.member.editaccount.6296') }}</p>
                <div class="input_wrap">
                  <input class="input_t" type="text" name="" value="eda0624" />
                </div>
              </li> -->
              <li class="join_phone">
                <p class="sub_title">
                  {{ $t('views.member.editaccount.4162') }}
                </p>
                <!-- Country Code -->

                <!-- Mobile Phone Number -->
                <div class="input_wrap">
                  <label for="firstmn" class="blind"
                    >휴대폰 번호 첫번째 자리 입력</label
                  >
                  <input
                    id="firstmn"
                    v-model="selectedMobilePrefix"
                    class="input_t read_only"
                    type="number"
                    maxlength="4"
                    placeholder="Mobile Prefix"
                    readonly
                    title="휴대폰 번호 첫번째 자리"
                  />
                </div>
                <div class="input_wrap ml-1">
                  <label for="secmn" class="blind"
                    >휴대폰 번호 두번째 자리 입력</label
                  >
                  <input
                    id="secmn"
                    v-model="phone1"
                    class="input_t read_only"
                    type="number"
                    pattern="/^-?\d+\.?\d*$/"
                    onkeypress="if(this.value.length==4) return false;"
                    name="phone1"
                    maxlength="4"
                    placeholder="0000"
                    readonly
                    title="휴대폰 번호 두번째 자리"
                  />
                </div>
                <div class="input_wrap">
                  <label for="thimn" class="blind"
                    >휴대폰 번호 세번째 자리 입력</label
                  >
                  <input
                    id="thimn"
                    v-model="phone2"
                    class="input_t read_only"
                    type="number"
                    pattern="/^-?\d+\.?\d*$/"
                    onkeypress="if(this.value.length==4) return false;"
                    name="phone2"
                    maxlength="4"
                    placeholder="0000"
                    readonly
                    title="휴대폰 번호 세번째 자리"
                  />
                </div>
              </li>
              <li>
                <p class="sub_title margin">
                  {{ $t('views.member.editaccount.6433') }}
                </p>
                <div class="input_wrap">
                  <label for="emailUpload" class="blind">이메일 입력</label>
                  <input
                    id="emailUpload"
                    v-model="email"
                    class="input_t read_only"
                    type="text"
                    maxlength="30"
                    name="email"
                    title="이메일 입력"
                    readonly
                  />
                  <p class="txt_message">
                    {{ $t('views.member.editaccount.6106') }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div
            v-if="!shouldShowBox"
            id="password_zone"
            ref="password_zone"
            class="box"
            data-detail="password_zone"
          >
            <ul class="form_wrap">
              <li>
                <p class="sub_title margin">새 비밀번호</p>
                <form class="input_wrap">
                  <input hidden="hidden" />
                  <input
                    id="newPassword"
                    v-model="newPassword"
                    autocomplete="off"
                    class="input_t"
                    type="password"
                    maxlength="15"
                    name="new_password"
                  />
                  <!-- :placeholder="$t('views.member.editaccount.197')" -->
                </form>
                ※ 공백 없이 8 ~ 15자의 영문/숫자조합
                <!-- div > form -->
              </li>
              <li :class="{ incorrect: !passwordMatch }">
                <p class="sub_title" :class="{ margin: !passwordMatch }">
                  새 비밀번호 확인
                </p>
                <form class="input_wrap">
                  <input hidden="hidden" />
                  <input
                    id="passwordCheck"
                    v-model="passwordCheck"
                    autocomplete="off"
                    class="input_t"
                    type="password"
                    maxlength="15"
                    name="password_check"
                    title="새 비밀번호 확인"
                  />
                  <!-- :placeholder="$t('views.member.editaccount.4965')" -->
                </form>
                <p v-show="!passwordMatch" class="txt_message">
                  <span>{{ $t('views.member.editaccount.9643') }}</span>
                </p>
              </li>
            </ul>
            <div class="btn_wrap">
              <button
                class="box_btn"
                :class="{ dull: !newPasswordValid }"
                :disabled="!newPasswordValid"
                @click="updatePassword"
              >
                <span class="an_t">비밀번호 변경</span>
              </button>
            </div>
          </div>
          <div class="box">
            <!-- 학부 category -->
            <!-- <ul v-if="memberTp == 1000" class="form_wrap">
              <li class="major float">
                <p class="sub_title">
                  {{ $t('views.member.editaccount.5209') }}
                </p>
                <div
                  v-for="(group, idx) in stdGroups"
                  :key="idx"
                  class="category_row_wrap"
                >
                  <CategoryRow :group="group" />
                  <button
                    v-if="idx !== 0"
                    type="button"
                    class="btn_delete_college an_a"
                    @click="deleteCategoryRow(idx)"
                  >
                    <span class="c_icon"></span
                    ><span class="an_t">{{
                      $t('views.member.editaccount.delete')
                    }}</span>
                  </button>
                </div>

                <button class="btn_insert_college an_a" @click="addCategoryRow">
                  <span class="an_t">{{
                    $t('views.member.editaccount.3219')
                  }}</span>
                </button>
              </li>
            </ul> -->
            <!-- 학부 category -->

            <!-- 대학교 -->
            <ul class="form_wrap">
              <li class="class-school">
                <p v-if="memberTp == 1000" class="sub_title">학교</p>
                <p v-if="memberTp == 2000" class="sub_title">강의 학교</p>
                <div class="college_wrap flex">
                  <div class="btn_wrap">
                    <button
                      class="box_btn"
                      :disabled="!isAfter30Days(getCurrentUser.unicolUpdDate)"
                      :class="{
                        dull: !isAfter30Days(getCurrentUser.unicolUpdDate)
                      }"
                      @click="toggleUnicolModal"
                    >
                      <span class="an_t">대학교 선택</span>
                    </button>
                  </div>
                  <div>
                    <label for="unicol"></label>
                    <input
                      id="unicol"
                      v-model="groups.unicolNm"
                      class="input_t read_only"
                      name="unicol"
                      placeholder="강의 학교를 선택하세요."
                      readonly
                    />
                  </div>
                  <p v-if="!isAfter30Days(getCurrentUser.unicolUpdDate)">
                    대학교 수정은
                    {{
                      addDaysToDate(getCurrentUser.unicolUpdDate, 31)
                        .toISOString()
                        .split('T')[0]
                    }}
                    부터 가능합니다.
                  </p>
                </div>
              </li>
              <li class="division" style="margin-top: 50px;">
                <p v-if="memberTp == 1000" class="sub_title">학부(학과)</p>
                <p v-if="memberTp == 2000" class="sub_title">강의 학부(학과)</p>
                <div class="input_wrap">
                  <label for="division"></label>
                  <input
                    id="division"
                    v-model="groups.division"
                    class="input_t read_only"
                    name="division"
                    placeholder="강의 학부를 입력하세요."
                    :disabled="!isAfter30Days(getCurrentUser.unicolUpdDate)"
                    @click="toggleDepartModal"
                  />
                </div>
              </li>
              <li v-if="memberTp == 2000" class="classNm">
                <p class="sub_title">강의명</p>
                <div class="input_wrap">
                  <label for="classNm"></label>
                  <input
                    id="classNm"
                    v-model="groups.classNm"
                    class="input_t"
                    name="classNm"
                    placeholder="강의명을 입력하세요."
                  />
                </div>
              </li>
              <li v-if="memberTp == 2000" class="publisher_group">
                <div class="flex">
                  <div class="btn_wrap">
                    <button
                      class="box_btn"
                      style="color: #ffffff; min-width: 118px;"
                      @click="togglePublishModal"
                    >
                      <span>출판사 선택</span>
                    </button>
                  </div>
                  <div class="btn_info">
                    <p>※ 선택한 출판사에 내 정보가 제공 됩니다.</p>
                  </div>
                </div>
              </li>
              <li v-if="memberTp == 2000" class="selected_publish">
                <div class="input_wrap flex">
                  <div v-for="(pub, i) in publishList" :key="i + 'publish'">
                    <span class="univNm">{{ pub.publisherNm }}</span>
                    <span class="close" @click="deletePublisher(pub)"
                      ><svg
                        width="10"
                        height="11"
                        viewBox="0 0 10 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 2.10227L5.72727 5.375L9 8.64773L8.27273 9.375L5 6.10227L1.72727 9.375L1 8.64773L4.27273 5.375L1 2.10227L1.72727 1.375L5 4.64773L8.27273 1.375L9 2.10227Z"
                          fill="#0F638F"
                          stroke="#0F638F"
                          stroke-linecap="square"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </li>
            </ul>
            <!-- 교강사 강의학교 -->
          </div>
          <div class="box">
            <ul class="form_wrap">
              <li class="info_reception">
                <p class="sub_title">
                  {{ $t('views.member.editaccount.8055') }}
                </p>
                <div class="join_check" data-detail="check_fl">
                  <div class="text_label">
                    <label>
                      <input
                        v-model="agreements.email"
                        value="email"
                        type="checkbox"
                        name="agree"
                      />
                      <em></em>
                      <span>{{ $t('views.member.editaccount.2884') }}</span>
                    </label>
                  </div>
                  <div class="text_label">
                    <label>
                      <input
                        v-model="agreements.messages"
                        value="sms"
                        type="checkbox"
                        name="agree"
                      />
                      <em></em>
                      <span>{{ $t('views.member.editaccount.smsmms') }}</span>
                    </label>
                  </div>
                </div>
                <div class="text_wrap">
                  <p>{{ $t('views.member.editaccount.640') }}</p>
                  <p>{{ $t('views.member.editaccount.4044') }}</p>
                </div>
              </li>
              <li class="info_secession">
                <div class="btn_wrap">
                  <p class="sub_title">
                    {{ $t('views.member.editaccount.7437') }}
                  </p>
                  <router-link :to="{ name: 'close_account' }" class="box_btn">
                    <span class="an_t">{{
                      $t('views.member.editaccount.9254')
                    }}</span>
                  </router-link>
                </div>
              </li>
            </ul>
            <div
              class="btn_wrap"
              data-detail="btn_bottom"
              style="width: 400px; margin: 20px auto 0 auto;"
            >
              <router-link
                :to="{ name: 'orders' }"
                class="box_btn dull"
                style="width: 45%;"
              >
                <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
              </router-link>
              <button
                class="box_btn"
                :disabled="!isVaild"
                :class="{ dull: !isVaild }"
                style="width: 45%;"
                @click="vaildChangeData"
              >
                <span class="an_t">{{
                  $t('views.member.editaccount.2518')
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 약관 동의 END-->
    <transition name="modal-fade">
      <Modal v-if="showModal" @close="closeModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="closeModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner">
              <p class="tac">{{ modalText }}</p>
              <div class="btnWrap">
                <button class="box_btn" @click="closeModal">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
    <!-- <transition name="modal-fade">
      <Modal v-if="showAgreeBox" @close="closeModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <AgreeBox />
            <div class="ly_inner">
              <p class="tac">{{ modalText }}</p>
              <div class="btnWrap">
                <button class="box_btn" @click="closeModal">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div></Modal
      ></transition
    > -->

    <!-- Address 찾기 modal -->
    <!-- <SearchAddressModal
      v-if="showAddressModal"
      @complete="onComplete"
      @close="toggleAddressModal"
    /> -->
    <unicolModal
      v-if="isShowUnicol"
      @close="toggleUnicolModal"
      @unicolInfo="selectUnicol"
    />
    <departmentModal
      v-if="isShowDepart"
      :groupsUnicolNm="groups.unicolNm"
      :groupsUnicolCd="groups.unicolCd"
      @close="toggleDepartModal"
      @departInfo="selectDepart"
    />
    <publishModal
      v-if="isShowPubl"
      @close="togglePublishModal"
      @pbList="selectPublishList"
    />
    <!-- 교강사 전환 얼랏 -->
    <transition name="modal-fade">
      <ChangeModal
        v-if="showNewModal"
        @close="closeEditModal"
        @goNext="completeChange"
      />
      <!-- 교강사 전환 얼랏 -->
    </transition>
  </div>
</template>

<script>
// import SearchAddressModal from '@/components/common/SearchAddressModal.vue'
// import CategoryRow from '@/components/auth/CategoryRow.vue'
import countryCodes from '../../data/countryCodes.json'
import unicolModal from '@/components/library/unicolModal.vue'
import departmentModal from '@/components/library/departmentModal.vue'
import publishModal from '@/components/library/publishModal.vue'
import ChangeModal from '@/components/library/ChangeModal.vue'
import AgreeBox from '../../components/common/AgreeBox.vue'

import { mapGetters } from 'vuex'
import {
  ACCOUNT_GET_INFO,
  ACCOUNT_UPDATE_PASSWORD,
  ACCOUNT_UPDATE_INFO
} from '@/store/types'

// import axios from 'axios'

export default {
  name: 'EditAccount',
  components: {
    unicolModal,
    publishModal,
    AgreeBox,
    ChangeModal,
    departmentModal
  },
  /*
  beforeRouteEnter(to, from, next) {
    if (to.query.token) {
      return next({ hash: 'password_zone' })
    }
    if (!to.params.verified) {
      return next({ name: 'login_to_edit' })
    }
    next()
  }, */
  data() {
    return {
      orgUser: [],
      memberTp: '',
      countryCodes,
      showAddressModal: false,
      showCountryMenu: false,
      isShowUnicol: false,
      isShowDepart: false,
      isShowPubl: false,
      showNewModal: false,
      publishList: [],
      name: '',
      birthDate: '',
      email: '',
      selectedCountry: 'South Korea',
      selectedCountryCode: '82',
      selectedMobilePrefix: '010',
      phone1: '',
      phone2: '',
      unicolNm: '',
      showTerms: false,
      groups: [
        // {
        //   division: '',
        //   department: '',
        //   catgryList: []
        // }
      ],
      stdGroups: [],
      agreements: {
        messages: false,
        email: false
      },

      // change Password
      newPassword: '',
      passwordCheck: '',

      // TEMP DATA
      invalidPhone: true,
      showModal: false,
      modalText: '',
      errors: {
        updatedPassword: '비밀번호가 변경되었습니다',
        badPassword: '사용할 수 없는 비밀번호 입니다.',
        updatedProfile: '사용자 정보가 수정되었습니다',
        updateProfileError:
          '사용자 정보를 수정하지 못했습니다. 다시 시도해 주세요.',
        updateComplete: '수정이 완료되었습니다.',
        updateMemberTp: '교 ·강사 회원 전환이 완료되었습니다.'
      },
      showCategoryMenu: false,
      showSubcategoryMenu: false,
      showAgreeBox: false,
      completeTerms: false,
      refresh: false
      // changeMember: true
    }
  },

  computed: {
    ...mapGetters(['getAccount', 'getCurrentUser', 'getPublishList']),
    genderText() {
      if (this.getCurrentUser) {
        return this.getCurrentUser.gender === 'M'
          ? '남'
          : this.getCurrentUser.gender === 'F'
          ? '여'
          : ''
      }
      return ''
    },
    shouldShowBox() {
      if (!this.getCurrentUser || !this.getCurrentUser.loginId) return false
      return (
        this.getCurrentUser.loginId.startsWith('naver_') ||
        this.getCurrentUser.loginId.startsWith('kakao_')
      )
    },
    passwordLength() {
      if (this.newPassword.length > 15 || this.newPassword.length < 8) {
        return false
      }
      return true
    },
    passwordMatch() {
      if (!this.newPassword || !this.passwordCheck) {
        console.log('000')
        return true
      }
      if (this.newPassword === this.passwordCheck) {
        console.log('111')
        return true
      }
      return false
    },
    newPasswordValid() {
      if (!this.passwordLength) {
        return false
      }
      if (!this.newPassword || !this.passwordCheck) {
        return false
      }
      if (this.passwordMatch) {
        return true
      }
      return false
    },
    isVaild() {
      if (
        this.memberTp == 2000 &&
        this.groups.unicolNm &&
        this.groups.division &&
        this.groups.classNm
        // this.publishList.length > 0
      ) {
        return true
      }
      if (this.memberTp == 1000) {
        return true
      }
      return false
    }
  },
  async mounted() {
    // this.resetPasswordFields()
    try {
      await this.$store.dispatch('fetchPublishList', { pageRow: '999' })
      // await this.$store.dispatch('fetchPublishList', { pageRow: '999' })
    } catch (err) {
      console.log(err)
    }
    const token = this.$route.query.token
    const that = this
    if (token) {
      /*
        1. Set token on localstorage
        2. If token is valid, allow password change
        3. If not, go to login page
      */
      localStorage.setItem('token', token)
    }
    if (!this.getAccount) {
      await this.$store.dispatch(ACCOUNT_GET_INFO)
    }

    that.setCurrentData()
  },
  methods: {
    closeEditModal() {
      this.showNewModal = false
      console.log('close')
    },
    completeChange() {
      this.showNewModal = false
      console.log('change')
      this.saveChanges('updateMemberTp')
    },
    changingMemberTp2() {
      if (this.getCurrentUser.memberTp == 1000 && this.memberTp == 2000) {
        this.showTerms = false
        this.completeTerms = false
        return
      }
      this.completeTerms = false
      this.showTerms = true
    },
    //#region
    setInTerms(terms) {
      this.completeTerms = true
      terms == 'return' ? (this.memberTp = 1000) : (this.setTerms = terms)
    },
    deletePublisher(pub) {
      this.publishList = this.publishList.filter((e) => {
        return e.publisherCd !== pub.publisherCd
      })
    },
    selectUnicol(school) {
      if (!school) {
        this.toggleUnicolModal()
        return
      }
      this.toggleUnicolModal()
      this.groups.unicolNm = school.unicolNm
      this.groups.unicolCd = school.unicolCd
    },
    selectDepart(diviForm) {
      if (!diviForm) {
        this.toggleDepartModal()
        return
      }
      this.toggleDepartModal()

      this.groups.selectedDepartments = diviForm
      // departInfo가 배열일 경우
      if (Array.isArray(diviForm)) {
        // departInfo의 모든 deptName을 groups.division에 설정

        this.groups.division = diviForm.map((dept) => dept.deptName)
      }
      // departInfo가 단일 객체일 경우
      else {
        this.groups.division = [diviForm.deptName]
      }
    },
    toggleUnicolModal() {
      this.isShowUnicol = !this.isShowUnicol
    },
    toggleDepartModal() {
      this.isShowDepart = !this.isShowDepart
    },
    selectPublishList(publishList) {
      this.togglePublishModal()
      this.publishList = publishList
    },
    togglePublishModal() {
      this.isShowPubl = !this.isShowPubl
    },
    setCurrentData() {
      const { countryCd, mobileNo, agreements } = this.getAccount

      const { memberNm, username, birthDate, memberTp } = this.getCurrentUser

      // const that = this
      this.memberTp = memberTp
      this.name = memberNm
      this.birthDate = birthDate
      this.email = username
      this.selectedCountryCode = countryCd ? countryCd.split('-')[0] : ''
      this.selectedMobilePrefix = mobileNo ? mobileNo.split('-')[1] : '010'
      this.phone1 = mobileNo ? mobileNo.split('-')[2] : ''
      this.phone2 = mobileNo ? mobileNo.split('-')[3] : ''
      this.agreements = agreements

      const diviForm = this.getCurrentUser.departmentList.map((e) => ({
        deptName: e.deptName,
        deptSeq: e.deptSeq
      }))

      if (memberTp == 1000) {
        const groups = {
          unicolCd: this.getCurrentUser.unicolCd,
          unicolNm: this.getCurrentUser.unicolNm,
          division: this.getCurrentUser.division,
          departmentList: diviForm,
          selectedDepartments: ''
        }
        this.groups = groups
      } else if (memberTp == 2000) {
        const groups = this.getAccount.groups
        for (let x of groups.publisherGroup) {
          this.getPublishList.filter((e) => {
            if (e.publisherCd == x) {
              this.publishList.push(e)
            }
            // return e.publisherCd == x
          })
        }

        this.groups = groups
      }
    },
    resetPasswordFields() {
      this.newPassword = ''
      this.passwordCheck = ''
    },

    async updatePassword() {
      if (!this.newPasswordValid) {
        return
      }
      try {
        this.$store.dispatch(ACCOUNT_UPDATE_PASSWORD, this.newPassword)
        this.toggleModal('updatedPassword')
        this.resetPasswordFields()
      } catch (err) {
        //Error: 사용할 수 없는 비밀번호 입니다.
        this.toggleModal('badPassword')
      }
    },

    // Select Country
    toggleCountryMenu() {
      this.showCountryMenu = !this.showCountryMenu
    },
    closeCountryMenu() {
      this.showCountryMenu = false
    },
    selectCountry(country) {
      this.selectedCountry = country.country
      this.selectedCountryCode = country.calling_code
      if (country.country == 'South Korea') {
        this.selectedMobilePrefix = '010'
      } else {
        this.selectedMobilePrefix = ''
      }
    },

    // BASIC MODAL FOR ERRORS
    toggleModal(value) {
      this.modalText = this.errors[value]
      this.showModal = !this.showModal
    },
    closeModal() {
      this.showModal = false
      this.refresh ? this.$router.go(this.$route.currentRoute) : ''
    },
    getUpdatedData() {
      const updated = {
        profile: {
          memberTp: this.memberTp,
          agreements: this.agreements,
          groups: {
            classNm: this.groups.classNm,
            // division: this.groups.division,
            unicolCd: this.groups.unicolCd,
            unicolNm: this.groups.unicolNm,
            departmentList: this.groups.selectedDepartments,
            publisherGroup: this.publishList.map((e) => e.publisherCd)
          }
        }
      }
      return updated
    },

    async vaildChangeData() {
      if (this.showTerms == true && this.completeTerms == true) {
        this.showNewModal = true
      } else {
        this.saveChanges('updateComplete')
      }
    },
    async saveChanges(text) {
      // add action to save changes
      const formattedData = this.getUpdatedData()

      try {
        await this.$store.dispatch(ACCOUNT_UPDATE_INFO, formattedData)
        await this.$store.dispatch(ACCOUNT_GET_INFO)
        // await this.setCurrentData()

        this.toggleModal(text)
        this.refresh = true
      } catch (err) {
        this.toggleModal('updateProfileError')
      }
    },

    addDaysToDate(dateString, days) {
      if (!dateString) {
        // dateString이 null 또는 undefined인 경우 현재 날짜를 기준으로 계산하거나 다른 기본값을 사용할 수 있습니다.
        const date = new Date()
        date.setDate(date.getDate() + days)
        return date
      }
      const date = new Date(dateString)
      date.setDate(date.getDate() + days)
      return date
    },

    isAfter30Days(dateString) {
      if (!dateString) {
        // dateString이 null 또는 undefined인 경우 true를 반환하여 항상 "수정 가능" 상태로 처리
        return true
      }
      const currentDate = new Date()
      const dateWith30Days = this.addDaysToDate(dateString, 30)

      // 현재 날짜가 30일을 더한 날짜보다 큰지 확인
      return currentDate > dateWith30Days
    },

    scrollTo(zone) {
      const element = this.$refs[zone]

      const top = element.offsetTop
      window.scrollTo(0, top)
    }
    // 출판사 코드 조회용...
  }
}
</script>
<style src="@/assets/css/page_member.css" scoped></style>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
.box_wrap .box + .box {
  position: relative;
  padding: 40px 56px 0px 56px;
  margin-top: 40px;
  border-top: 1px solid #d6e7f1;
}
.box_wrap .box {
  &.renew_style {
    padding: 0 56px 0px 56px;
  }
}
.form_wrap > li + li {
  margin-top: 20px;
}
.form_wrap > li .input_wrap {
  max-width: 510px;
}
.input_wrap::-webkit-scrollbar {
  width: 10px;
  height: 5px;
  border-radius: 10px;
}
.input_wrap::-webkit-scrollbar-thumb {
  background-color: rgb(15, 99, 143);
  border-radius: 10px;
}
.input_wrap::-webkit-scrollbar-track {
  border-radius: 10px;
}
.member_type {
  // height: 100px;
  span {
    // line-height: 2em;
    font-size: 1.2em;
    position: relative;
    top: -5px;
  }
  input[type='radio'] {
    // margin-top: 40px;
    appearance: none;
    width: 24px;
    height: 24px;
    border-radius: 100%;
    margin-right: 1rem;
    background-color: #f0f5fa;
    border: 0.5em solid #f0f5fa;
  }

  input[type='radio']:checked {
    appearance: none;
    width: 24px;
    height: 24px;
    border-radius: 100%;
    margin-right: 1rem;
    border: 0.5em solid #f0f5fa;
    background-color: #36a5c2;
  }
}
.college_wrap {
  position: relative;
  p {
    position: absolute;
    bottom: -31px;
    left: 0;
    font-size: 15px;
    color: #1f53cc;
  }
}
.address_wrapper {
  margin: 20px 0 80px 0 !important;
}

.btnWrap {
  padding: 0px 25px 25px 25px;
  margin-top: 50px;
  .box_btn {
    width: 100% !important;
  }
}

.ly_inner {
  padding: 22px 25px 0px 25px !important;
}
.read_only {
  background: #f0f5fa;
  border: 1px solid #a7b4c0;
}
.address_sub {
  font-size: 16px;
  line-height: 24px;
  color: #000;
  font-weight: 500;
  margin-right: 10px;
}
.class-school {
  margin-bottom: 10px;
  .flex {
    div {
      max-width: 370px;
      flex: 1 0 auto;
    }
    .btn_wrap {
      flex-grow: 0;
      margin-right: 12px;
    }
  }
}
.publisher_group {
  .flex {
    align-items: center;

    .btn_wrap {
      margin-right: 10px;
      // flex: 1;
    }
    .btn_info {
      flex: 2;
    }
  }
}
.selected_publish .flex {
  width: 100%;
  height: 48px;
  border: 1px solid #d5dff3;
  border-radius: 12px;
  overflow-x: scroll;
  div {
    line-height: 48px;
    display: flex;
    flex-wrap: nowrap;
    flex-shrink: 0;
    min-width: 48px;
    .univNm {
      padding-left: 10px;
      display: inline-block;
    }
    .close {
      padding: 0 5px;
      cursor: pointer;
    }
  }
}
.address_title {
  margin-top: 5px;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 24px;
  color: #778899;
}
.name_stl,
.bir_stl,
.gender_stl {
  font-size: 16px;
}
.gender_stl {
  display: inline-block;
}
@media (min-width: 767px) {
  .country_list {
    width: 68% !important;
    margin-right: 100%;
  }
}

@media (max-width: 767px) {
  .align_chk {
    margin-left: 0px !important;
  }
  .join_st .section {
    padding: 0;
  }
  .class-school {
    .flex {
      flex-direction: column;
      #unicol {
        margin-top: 20px;
      }
    }
  }
  .selected_publish {
    margin-top: 20px !important;
  }
  .member_type input[type='radio'] {
    margin-right: 10px !important;
  }
  .btn_wrap[data-detail*='btn_bottom'] {
    width: 260px !important;
  }
}

.select_area,
.select_item,
.select_option {
  width: 100%;
}

.select_area {
  margin-top: 10px;
  margin-bottom: 10px;
}

.input_prefix {
  width: 110px;
}

.country_list {
  width: 100%;
  margin-bottom: 10px;
}

.country_dropdown {
  width: 100%;
}

.inputMessage {
  width: 100% !important;
}

.select_option.gray.fullWidth {
  width: 100%;
}
ul.select_list {
  height: 300px;
  overflow-y: scroll;
}

.category_row_wrap {
  width: 100%;
  margin: 0px;
  margin-top: 10px;
  border-bottom: #d6e7f1 solid 1px;
  padding-bottom: 8px;
}

.btn_insert_college {
  display: inline-block;
  width: 190px;
  height: 48px;
  margin-top: 10px;
  padding: 13px 16px;
  background: url('../../assets/images/icon_insert.png') 160px 15px no-repeat;
  background-size: 12px 12px;
  border: 1px dashed rgba(119, 136, 153, 0.5);
  border-radius: 3px;
  .an_t {
    font-weight: 500;
    line-height: 20px;
    text-align: left;
    color: #778899;
  }
}
.btn_delete_college {
  display: inline-block;
  width: 48px;
  height: 28px;
  margin-left: 10px;
  margin-top: 10px;
  vertical-align: middle;
  text-indent: -9999px;

  .c_icon {
    display: block;
    width: 48px;
    height: 28px;
    background-position: 0px -200px;
  }
}

input:read-only {
  opacity: 0.9;
}

.section {
  &.full {
    background-color: #ffffff;
  }
}
.box_btn {
  &.line {
    margin-top: 50px;
  }
}
.text_label {
  label {
    display: flex;
  }
}
.wid_style {
  width: auto;
}

@media (max-width: 480px) {
  .college_wrap p {
    bottom: -51px;
  }
}
</style>
